'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PERFORMANCE_END_STORY_ACTION = exports.PERFORMANCE_END_STORY_ACTION = 'PERFORMANCE_END_STORY_ACTION';

/**
 * @export
 * @param {string} screenKey
 */
var performanceEndStory = function performanceEndStory(screenKey) {
  return {
    type: PERFORMANCE_END_STORY_ACTION,
    screenKey: screenKey
  };
};

exports.default = performanceEndStory;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/screen/actions/PerformanceEndStoryAction.js
// module id = 757
// module chunks = 10